module.exports = __webpack_public_path__ + "static/media/ki.3d513869.svg";